import {useEffect, useRef} from 'react';
import {observer} from 'mobx-react';
import {Button, Label, Surface} from '@vidazoo/ui-kit';
import {useNavigate} from 'react-router-dom';
import {useDashboardsListContext} from '../../../../list/context/DashboardsListContext';
import {DashboardCard} from '../../../../list/components/DashboardsList';
import UrlsService from '../../../../../../common/router/services/urlsService.mdl';
import theme from './theme.module.scss';

export default observer(function DashboardSwitcher() {
    const {model} = useDashboardsListContext();
    const navigate = useNavigate();
    const open = model.isDashboardsListOpen;
    const scroller = useRef<HTMLDivElement>(null);
    useEffect(() => {
        void model.items.fetch();
        void model.cloudManager.initialize();
        void model.chartsManager.navigationItems.fetch();
    }, [model]);
    useEffect(() => {
        const element = scroller.current;
        if (!element || !open) return;
        const wheel = (event: WheelEvent) => {
            if (!event.deltaY || event.deltaX || element.scrollWidth <= element.clientWidth) return;
            event.preventDefault();
            element.scrollLeft += event.deltaY;
        };
        element.addEventListener('wheel', wheel, {passive: false});
        return () => element.removeEventListener('wheel', wheel);
    }, [open]);
    const favorites = model.data.filter(item => !!model.cloudManager.dashboardsStarsById[item._id]);
    const others = model.data.filter(item => !model.cloudManager.dashboardsStarsById[item._id]);
    return <div>
        {open && <Surface className={theme.panel} level={1} id="dashboard-switcher" role="region" aria-label="Dashboard switcher">
            <div className={theme.header}>
                <Label weight={600} uppercase={false}>Dashboards</Label>
                <Button type="button" iconName="icon-plus-small" medium blue
                    onClick={() => navigate(UrlsService.createDashboard())}>Create Dashboard</Button>
            </div>
            <div ref={scroller} className={theme.scroller}>
                <div className={theme.cards}>
                    {[...favorites, ...others].map(item => <DashboardCard key={item._id} item={item}/>)}
                </div>
            </div>
        </Surface>}
        <Button className={theme.toggle} type="button" iconName={open ? 'icon-arrow-up-small' : 'icon-arrow-down-small'}
            medium green aria-expanded={open} aria-controls="dashboard-switcher" onClick={() => {model.isDashboardsListOpen = !open;}}>Dashboards</Button>
    </div>;
});
